<template>
    <div>
        <Transacting v-if="$store.state.roles == 'AdmAgent'"></Transacting>
        <TransactingAdmin
            v-if="
                $store.state.roles == 'AdmSupervisor' ||
                    $store.state.roles == 'Administrator' ||
                    $store.state.roles == 'AdministrationPpW'
            "
        ></TransactingAdmin>
    </div>
</template>

<script>
import TransactingAdmin from '@/components/Administration/TransactingAdmin.vue';
import Transacting from '@/components/Administration/Transacting.vue';
export default {
    name: 'TransactingView',
    components: {
        TransactingAdmin,
        Transacting
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title = 'Transacting';
            }
        }
    }
};
</script>
